<qt-dialog>
  <div qtDialogTitle>
    @if (!edit) {
      {{ 'GNR_ADD_EMPLOYEE' | translate }}
    }
    @if (edit) {
      {{ 'CMD_EDIT' | translate }}
    }
  </div>
  <div qtDialogContent class="customer-form__content">
    <form class="customer-form" novalidate fxLayout="column">
      <div fxLayout fxLayoutGap="1rem" fxLayoutAlign="start">
        @if (media.isActive('gt-sm')) {
          <mat-icon class="material-icon-gray"> email </mat-icon>
        }
        <mat-form-field appearance="outline" fxFlex>
          <input
            qtKeyboard
            qtInputScroll
            cdkFocusInitial
            matInput
            type="text"
            [placeholder]="'GNR_EMAIL' | translate"
            [formControl]="email"
            (blur)="checkEmail(email)"
            autocapitalize="none"
            data-testid="employee_email_input"
            [required]="!edit" />
          <mat-error [control]="email"></mat-error>
        </mat-form-field>
      </div>
      <section>
        <div
          fxLayout.gt-xs="row"
          fxLayout="column"
          fxLayoutGap="0px"
          fxLayoutGap.gt-xs="1rem"
          fxLayoutAlign.gt-xs="start">
          @if (media.isActive('gt-sm')) {
            <mat-icon class="material-icon-gray">swap_horiz</mat-icon>
          }
          <mat-form-field appearance="outline" fxFlex>
            <mat-select
              [required]="!edit"
              [placeholder]="'GNR_ROLE' | translate"
              [formControl]="roles">
              @for (role of staffRoles(); track role) {
                <mat-option [value]="role.id">
                  {{ role.name | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-error [control]="roles"></mat-error>
          </mat-form-field>
        </div>
      </section>
      @if (edit) {
        <div fxLayout fxLayoutGap="1rem" fxLayoutAlign="start center">
          @if (media.isActive('gt-sm')) {
            <mat-icon class="material-icon-gray">person_check</mat-icon>
          }
          <mat-checkbox [formControl]="active">{{
            'GNR_ACTIVE' | translate
          }}</mat-checkbox>
        </div>
      }
    </form>
    @if (!edit && !link) {
      <mat-expansion-panel
        #panel
        class="mat-elevation-z0 language-form"
        [hideToggle]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="material-icon-gray language-form__indicator">
              @if (panel.expanded) {
                <mat-icon>keyboard_arrow_up</mat-icon>
              } @else {
                <mat-icon>keyboard_arrow_down</mat-icon>
              }
            </div>
            <span
              >{{ 'GNR_LANG_PREF' | translate }} ({{
                currentLanguageName | async
              }})</span
            >
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field appearance="outline">
          <mat-select
            [placeholder]="'GNR_LNG_PREFERED' | translate"
            [formControl]="inviteLanguage">
            @for (languge of languages(); track languge) {
              <mat-option [value]="languge.id">
                {{ languge.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-expansion-panel>
    }
  </div>
  <div qtDialogActions>
    <button mat-button matDialogClose>{{ 'GNR_CANCEL' | translate }}</button>
    <button
      mat-button
      class="qt-dialog-primary-button"
      (click)="onSubmit()"
      data-testid="employee_invite_button">
      @if (!edit) {
        {{ 'GNR_INVITE' | translate }}
      } @else {
        {{ 'CMD_SAVE' | translate }}
      }
    </button>
  </div>
</qt-dialog>
